import 'jquery';
import moment from 'moment';
import 'bootstrap-daterangepicker';

$(() => {
    /** @type {JQuery<HTMLInputElement>} */
    var $checkin = $('[name="checkin"]');

    /** @type {JQuery<HTMLInputElement>} */
    var $checkout = $('[name="checkout"]');

    /** @type {JQuery<HTMLDivElement>} */
    const $guestsModal = $('#guestsModal');

    const $datepickerModal = $('#datepickerModal').on('click', '#clearDates', () => {
        $datepicker.data('daterangepicker').clickCancel();
    });

    $(document).on('click', '[data-toggle="datepicker"]', (event) => {
        event.preventDefault();

        $datepicker.data('daterangepicker').show();
    });

    const $datepicker = $('#datepicker').daterangepicker({
        parentEl: '#datepickerModal .modal-body',
        // opens: 'center',
        startDate: $checkin.val() ? moment($checkin.val(), 'YYYY-MM-DD') : moment().startOf('day'),
        endDate: $checkout.val() ? moment($checkout.val(), 'YYYY-MM-DD') : moment().startOf('day').add(1, ' day'),
        minDate: moment().startOf('day'),
        autoUpdateInput: true,
        autoApply: true,
        applyButtonClasses: 'd-none',
        cancelButtonClasses: 'd-none',
        locale: {
            format: 'DD MMM',
            separator: ' – ',
        },
        /**
         * @param {moment.Moment} date
         * @returns {bool}
         */
        isInvalidDate(date) {
            for (const [from, to] of window['disabledDates'] || []) {
                if (date.isBetween(from, to, 'day', '[]')) {
                    return true;
                }
            }

            return false;
        },
    },
    (start, end) => {
        if (end.isSame(start, 'day')) {
            $datepicker.data('daterangepicker').setEndDate(end.add(1, 'day'));
        }

        console.log({ start, end });

        $checkin.each((index, checkin) => {
            checkin.value = start.format('YYYY-MM-DD');
            checkin.dispatchEvent(new InputEvent('input'));
        });

        $checkout.each((index, checkout) => {
            checkout.value = end.format('YYYY-MM-DD');
            checkout.dispatchEvent(new InputEvent('input'));
        });

        $('#search-checkin span').text(start.format('DD MMM'));
        $('#book-mobile-checkin span').text(start.format('DD MMM'));
        $('#book-desktop-checkin span').text(start.format('DD MMM'));

        $('#search-checkout span').text(end.format('DD MMM'));
        $('#book-mobile-checkout span').text(end.format('DD MMM'));
        $('#book-desktop-checkout span').text(end.format('DD MMM'));
    }).on('apply.daterangepicker', (ev, picker) => {
        console.log({ ev, picker });

        if (! $guestsModal.data('saved')) {
            $guestsModal.modal('show');
        }
    }).on('cancel.daterangepicker', (ev, picker) => {
        picker.setStartDate(moment().startOf('day'));
        picker.setEndDate(moment().startOf('day').add(1, 'day'));

        $checkin.each((index, checkin) => {
            checkin.value = '';
            checkin.dispatchEvent(new InputEvent('input'));
        });

        $checkout.each((index, checkout) => {
            checkout.value = '';
            checkout.dispatchEvent(new InputEvent('input'));
        });

        $('#search-checkin span').text('Arrive');
        $('#book-mobile-checkin span').text('Arrive');
        $('#book-desktop-checkin span').text('Arrive');

        $('#search-checkout span').text('Depart');
        $('#book-mobile-checkout span').text('Depart');
        $('#book-desktop-checkout span').text('Depart');
    }).on('show.daterangepicker', (ev, picker) => {
        $datepickerModal.modal('show');
        picker.container.addClass('d-flex');
    }).on('hide.daterangepicker', (ev, picker) => {
        $datepickerModal.modal('hide');
        picker.container.removeClass('d-flex');
    });

    $datepicker.data('daterangepicker').outsideClick = (e) => {
        var picker = $datepicker.data('daterangepicker');
        var target = $(e.target);

        // if the page is clicked anywhere except within the daterangerpicker/button
        // itself then call this.hide()
        if (
            // ie modal dialog fix
            e.type == "focusin" ||
            target.closest(picker.element).length ||
            target.closest(picker.container).length ||
            target.closest('.calendar-table').length ||
            target.is('#clearDates')
            ) return;
        picker.hide();
        picker.element.trigger('outsideClick.daterangepicker', picker);
    };
});

/** @param {[string, string][]|null} dates */
window['setDisabledDates'] = (dates) => {
    window['disabledDates'] = (dates || []).map(([from, to]) => [moment(from), moment(to)]);
}
